import { withInstall } from '@touchvue/utils';
import Float from './src/Float.vue';

export const ToFloat = withInstall(Float);
export default ToFloat;

export * from './src/float';
